// Smart header (spec §12.3/§15.2): transparente arriba, oculto al bajar,
// flotante al subir.
export function initSmartHeader() {
	const header = document.querySelector("[data-smart-header]");
	if (!header) return;

	let lastScroll = window.scrollY;
	let ticking = false;

	const update = () => {
		const current = window.scrollY;

		if (current <= 20) {
			header.classList.add("header-at-top");
			header.classList.remove("header-visible", "header-hidden");
		} else {
			header.classList.remove("header-at-top");

			if (current > lastScroll && current > 120) {
				header.classList.add("header-hidden");
				header.classList.remove("header-visible");
			} else if (current < lastScroll) {
				header.classList.add("header-visible");
				header.classList.remove("header-hidden");
			}
		}

		lastScroll = current;
		ticking = false;
	};

	window.addEventListener(
		"scroll",
		() => {
			if (!ticking) {
				window.requestAnimationFrame(update);
				ticking = true;
			}
		},
		{ passive: true }
	);

	update();
}
